var map = {
	"./b_b.png": 29,
	"./b_w.png": 30,
	"./k_b.png": 31,
	"./k_w.png": 32,
	"./n_b.png": 33,
	"./n_w.png": 34,
	"./p_b.png": 35,
	"./p_w.png": 36,
	"./q_b.png": 37,
	"./q_w.png": 38,
	"./r_b.png": 39,
	"./r_w.png": 40
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 15;